<template>
  <section id="mv" class="mv js-first-view" data-scroll-section>
    <img
      data-scroll
      :data-scroll-speed="$store.state.isMobile ? 1.5 : 2.5"
      data-scroll-delay="0.05"
      data-scroll-position="top"
      data-scroll-target=".mv"
      class="copy"
      src="@/assets/copy.png"
      alt=""
    />

    <div class="model tommy">
      <img
        data-scroll
        data-scroll-speed="1.8"
        data-scroll-delay="0.05"
        data-scroll-position="top"
        data-scroll-target=".mv"
        class="person"
        src="@/assets/tommy-full.png"
        alt=""
      />
      <img class="tag" src="@/assets/tommy-tag.png" alt="" />
    </div>
    <div class="model kanta">
      <img
        data-scroll
        data-scroll-speed="1"
        data-scroll-delay="0.05"
        data-scroll-position="top"
        data-scroll-target=".mv"
        class="person"
        src="@/assets/kanta-full.png"
        alt=""
      />
      <img class="tag" src="@/assets/kanta-tag.png" alt="" />
    </div>

    <svg
      class="tri tri-01"
      width="893"
      height="744"
      viewBox="0 0 893 744"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="MVTri01">
          <rect
            class="mask-rect"
            fill="white"
            x="0"
            y="0"
            width="893"
            height="744"
          />
        </mask>
      </defs>
      <path
        mask="url(#MVTri01)"
        d="M838.439 43.9556L108.423 172.015L22.4451 689.049L838.439 43.9556Z"
        fill="white"
      />
    </svg>

    <svg
      class="tri tri-02"
      width="1071"
      height="659"
      viewBox="0 0 1071 659"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="MVTri02">
          <rect
            class="mask-rect"
            fill="white"
            x="-40"
            y="0"
            width="1071"
            height="659"
          />
        </mask>
      </defs>
      <path
        mask="url(#MVTri02)"
        d="M1067.61 54.7115L246.619 56.1227L54.7983 604.108L1067.61 54.7115Z"
        fill="white"
      />
    </svg>

    <div class="mv__name-wrap">
      <span
        data-scroll
        data-scroll-direction="horizontal"
        data-scroll-speed="9"
        data-scroll-delay="0.05"
        data-scroll-target="#mv"
        class="mv__name"
        >MIZUTAMARI BOND MIZUTAMARI BOND MIZUTAMARI BOND</span
      >
    </div>

    <svg
      class="tri tri-03"
      width="995"
      height="632"
      viewBox="0 0 995 632"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="MVTri03">
          <rect
            class="mask-rect"
            fill="white"
            x="0"
            y="0"
            width="995"
            height="632"
          />
        </mask>
      </defs>
      <path
        mask="url(#MVTri03)"
        d="M999.422 181.476L104 103.356L389.1 204.575L190.32 221.596L922.912 526.929L999.422 181.476Z"
        fill="white"
      />
    </svg>

    <div
      data-scroll
      data-scroll-speed="-2"
      data-scroll-delay="0.05"
      class="scroll"
    >
      <span class="label">SCROLL</span>
      <span class="bar"></span>
    </div>
  </section>
</template>

<script>
import gsap from 'gsap'

/* mixin */
import scrollTrigger from '@/mixins/scrollTrigger.js'

export default {
  mixins: [scrollTrigger],

  watch: {
    async '$store.state.isShowView'(isShowView) {
      isShowView && this.onEnter()
    }
  },

  methods: {
    onEnter() {
      const tl = gsap.timeline({ delay: 0.5 })

      tl.from(this.$el.querySelector('.mv__name-wrap'), {
        skewY: 25,
        x: 40,
        opacity: 0,
        ease: 'elastic.out(1.1, 1)',
        duration: 0.6
      })

      tl.from(
        this.$el.querySelectorAll('.model'),
        {
          duration: 0.65,
          skewX: (i) => {
            let skewX = 0
            switch (i) {
              case 0:
                skewX = -4
                break
              case 1:
                skewX = 4
                break
            }
            return skewX
          },
          scale: 1.2,
          x: (i) => {
            let x = 0
            switch (i) {
              case 0:
                x = '20%'
                break
              case 1:
                x = '-100%'
                break
            }
            return x
          },
          y: (i) => {
            let y = 0
            switch (i) {
              case 0:
                y = -100
                break
              case 1:
                y = -100
                break
            }
            return y
          },
          opacity: 0,
          ease: 'elastic.out(1.5, 1.5)',
          stagger: 0.15
        }
        // `-=0.5`
      )
      tl.from(
        this.$el.querySelectorAll('.mask-rect'),
        {
          duration: 0.75,
          transform: (i) => {
            return i === 1 ? 'translate3d(100%,0,0)' : 'translate3d(-100%,0,0)'
          },
          ease: 'expo.out'
        },
        `-=0.5`
      )

      tl.from(
        this.$el.querySelector('.copy'),
        {
          duration: 0.65,
          opacity: 0,
          skewX: -16,
          translateX: '100%',
          ease: 'expo.out'
        },
        '-=0.25'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 30rem;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9;

  @media screen and (max-width: $breakpoint-mobile) {
    height: 20rem;
    padding: 0;
  }

  .bar {
    position: relative;
    display: block;
    width: 0.1rem;
    height: 20rem;
    overflow: hidden;
    background: #fff;

    @keyframes scrolldown {
      0% {
        transform: translate(0, -6rem);
        height: 0rem;
      }
      90% {
        transform: translate(0, 20rem);
        height: 6rem;
      }
      100% {
        transform: translate(0, 20rem);
        height: 6rem;
      }
    }

    &:after {
      position: absolute;
      content: '';
      display: block;
      width: 100%;
      height: 0;
      transform: translate(0, 0);
      background: var(--main-color);
      animation: scrolldown 4s $ease backwards infinite;
    }
  }

  .label {
    font-size: 1rem;
    letter-spacing: 0.3em;
    color: #fff;
    font-weight: 500;
    margin: 2rem 0 0;
    transform: translate(2rem, 3.4rem) rotate(90deg);
  }
}
.mv {
  position: relative;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 0;
  background: linear-gradient(45deg, #e70013, #bd0414);

  @media screen and (max-width: $breakpoint-mobile) {
    height: calc(var(--vh, 1vh) * 75);
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    height: 50vh;
  }

  .copy {
    position: absolute;
    left: -2rem;
    bottom: -2rem;
    z-index: 10;
    max-width: 88rem;
    @media screen and (max-width: $breakpoint-mobile) {
      width: 100%;
      left: 0;
      bottom: 0;
    }
  }

  .model {
    position: absolute;
    transform-origin: center;

    &.tommy {
      left: 50%;
      transform: translate(calc(-50% + 40rem), 0);
      @media screen and (max-width: $breakpoint-mobile) {
        top: 4rem;
        left: 46%;
        transform: translate(calc(-50% + 18rem), 0);
      }

      .person {
        width: 110rem;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 56rem;
        }
      }

      .tag {
        position: absolute;
        width: 20rem;
        top: 35rem;
        left: 52rem;
        z-index: 9;
        @media screen and (max-width: $breakpoint-mobile) {
          top: 20rem;
          left: 18rem;
          width: 15rem;
        }
      }
    }
    &.kanta {
      top: 6rem;
      left: 50%;
      transform: translate(calc(-50% - 30rem), 0);
      @media screen and (max-width: $breakpoint-mobile) {
        top: 5rem;
        transform: translate(calc(-50% - 10rem), 0);
        z-index: -9;
      }

      .person {
        width: 80rem;
        @media screen and (max-width: $breakpoint-mobile) {
          width: 42rem;
        }
      }
      .tag {
        position: absolute;
        width: 20rem;
        top: 35rem;
        left: 10rem;
        z-index: 9;
        @media screen and (max-width: $breakpoint-mobile) {
          top: 20rem;
          left: 8rem;
          width: 14rem;
        }
      }
    }
  }

  &__name-wrap {
    position: absolute;
    top: 35rem;
    width: 100%;
    left: 0;
    transform: skewY(-6deg);
    z-index: -9;
    transform-origin: 0 0;
    @media screen and (max-width: $breakpoint-mobile) {
      display: none;
    }
  }

  &__name {
    position: absolute;
    left: 0;
    font-size: 40rem;
    font-weight: 900;
    white-space: nowrap;
    color: #ffffff10;
    @media screen and (max-width: $breakpoint-mobile) {
      font-size: 20rem;
      z-index: -9;
    }
  }

  .tri {
    position: absolute;
    z-index: -9;
    @media screen and (max-width: $breakpoint-mobile) {
      z-index: -10;
    }

    &.tri-01 {
      width: 80rem;
      top: 30rem;
      left: -10rem;
      @media screen and (max-width: $breakpoint-mobile) {
        left: -10rem;
        top: 10rem;
      }
    }

    &.tri-02 {
      width: 150rem;
      top: -40rem;
      right: -116rem;
      @media screen and (max-width: $breakpoint-mobile) {
        display: none;
      }
    }
    &.tri-03 {
      width: 100rem;
      right: -30rem;
      bottom: -35rem;
      z-index: 9;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 65rem;
      }
    }
  }
}
</style>
